export const SERVICES_DATA = [
  {
    num: "01",
    title: "Paid Ads",
    subtitle: "Sales & Lead Generation",
    desc: "We generate qualified leads, sales, and bookings through performance-focused paid advertising engineered to convert.",
    bullets: [
      "Meta Ads — Facebook & Instagram",
      "Google Ads",
      "TikTok Ads",
      "LinkedIn Ads",
      "ChatGPT Ads / AI-driven ad strategy",
    ],
    icon: "Target",
  },
  {
    num: "02",
    title: "Web Design",
    subtitle: "& Development",
    desc: "We build and improve websites engineered to convert visitors into customers with intent.",
    bullets: [
      "Redesigning old sites into high-converting websites",
      "Website design and development",
      "Landing page design",
      "Conversion-focused website structure",
    ],
    icon: "Code2",
  },
  {
    num: "03",
    title: "Creative",
    subtitle: "Brand & Visuals",
    desc: "We create visual assets that help brands stand out, command attention, and sell better online.",
    bullets: [
      "Video editing",
      "Graphic design",
      "Brand identity design",
      "UI/UX design",
      "Ad creatives & social media post design",
    ],
    icon: "Brush",
  },
  {
    num: "04",
    title: "SEO & AI SEO",
    subtitle: "Organic Visibility",
    desc: "We help businesses get found organically through search engines, local search, YouTube, and AI platforms.",
    bullets: [
      "SEO for ranking on Google",
      "Local SEO to drive nearby customers",
      "YouTube SEO for growth & reach",
      "Google Business Profile / GMB optimization",
      "AI SEO for ChatGPT, Claude, Gemini",
    ],
    icon: "Search",
  },
  {
    num: "05",
    title: "Social Media",
    subtitle: "Management",
    desc: "We manage and grow business social media with a focus on trust, engagement, and customer growth.",
    bullets: [
      "Social media management",
      "Organic social media growth",
      "Content planning and posting",
      "Customer queries by human support",
      "Community management",
    ],
    icon: "Users",
  },
  {
    num: "06",
    title: "AI Solutions",
    subtitle: "& Automation",
    desc: "We build AI systems that help businesses save time, improve customer handling, and scale operations.",
    bullets: [
      "AI automation for sales & operations",
      "Dedicated AI agents with long-term memory",
      "Multi-agent systems: sales, support, follow-up",
      "Voice AI for inbound & outbound calls",
      "Custom AI built around your business",
    ],
    icon: "Bot",
  },
  {
    num: "07",
    title: "Software",
    subtitle: "Development",
    desc: "We build custom digital products for businesses that need more than a standard website.",
    bullets: [
      "Custom software development",
      "Mobile apps for iOS and Android",
      "Business dashboards",
      "Internal tools and systems",
      "CRM or workflow-based solutions",
    ],
    icon: "Terminal",
  },
  {
    num: "08",
    title: "Virtual Assistants",
    subtitle: "Human VA Services",
    desc: "Dedicated remote virtual assistants to help companies manage daily work and operations.",
    bullets: [
      "Dedicated virtual assistant support",
      "Admin task management",
      "Daily business operations support",
      "Customer support assistance",
      "Data entry, scheduling, follow-ups",
    ],
    icon: "Headphones",
  },
  {
    num: "09",
    title: "Cinema\u00adtography",
    subtitle: "Story-Driven Video",
    desc: "Cinematic video production that builds brands, sells products, and captures moments worth remembering.",
    bullets: [
      "Brand & commercial films",
      "Aerial / drone cinematography",
      "Event & lifestyle coverage",
      "Social-cut edits for reels & ads",
      "Full production, direction & post",
    ],
    icon: "Film",
  },
  {
    num: "10",
    title: "Photography",
    subtitle: "Editorial & Commercial",
    desc: "High-end photography for brands, personalities, and campaigns — shot to convert and to be remembered.",
    bullets: [
      "Brand & product photography",
      "Portrait & personal-brand shoots",
      "Event & lifestyle coverage",
      "Editorial-grade retouching",
      "Studio & on-location capture",
    ],
    icon: "Camera",
  },
];

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_web-forge-1526/artifacts/wcm2184a_copy_0A7BED0C-D352-4F7E-B671-694AEFB53BCB.jpeg",
  infographic: "https://customer-assets.emergentagent.com/job_web-forge-1526/artifacts/dgtc6usk_20D412D3-5717-49ED-B669-1F2DBD8AB3C1.png",
};

export const CLIENT_LOGOS = [
  {
    name: "Wave Helicopters",
    src: "https://customer-assets.emergentagent.com/job_web-forge-1526/artifacts/ehjo2bsq_IMG_5227.jpeg",
    bg: "light",
  },
  {
    name: "Wings Air Helicopters",
    src: "https://customer-assets.emergentagent.com/job_web-forge-1526/artifacts/35cfht8d_IMG_2147.png",
    bg: "dark",
  },
  {
    name: "ILandMiami — Fly In Style, Land In Luxury",
    src: "https://customer-assets.emergentagent.com/job_web-forge-1526/artifacts/gm137i6r_5FE3C019-137D-4A8D-8BD7-D69BCC0194E0.png",
    bg: "dark",
  },
  {
    name: "Zebra — Stripes of Power",
    src: "https://customer-assets.emergentagent.com/job_web-forge-1526/artifacts/7flaav29_IMG_8299.jpeg",
    bg: "dark",
  },
  {
    name: "Palm Breeze Charters",
    src: "https://customer-assets-cm19k8pv.emergentagent.net/job_web-forge-1526/artifacts/xf22mnnb_copy_80FEB2EB-05D8-40AD-A033-1FB31BE843B3.png",
    bg: "light",
  },
  {
    name: "3iple.com",
    src: "https://customer-assets-cm19k8pv.emergentagent.net/job_web-forge-1526/artifacts/ti13o1v1_55A05E99-7981-4C2C-B91E-25E023CCF9CA.webp",
    bg: "light",
  },
];
